import { FileType } from "./file-type";

export class GlobalBookingFile {

    constructor(
        public name: string,
        public needsToBeCompleted: boolean,
        public fileType: FileType | null,
        public canBeSentToStudent: boolean,
        public canBeSentToSchool: boolean,
        public id?: number,
        public size?: number
    ){}
}
